module.exports = __webpack_public_path__ + "static/media/clock.d6b8a507.svg";